function pad(number) {
  return number < 10 ? '0' + number : number;
}

export default function formatSecondsShort(
  totalSeconds: number,
  forceHours = false,
  includeUnits = false,
  includeSeconds = true
): string {
  const hours = Math.floor(totalSeconds / 3600) || 0;
  const minutes = Math.floor((totalSeconds - hours * 3600) / 60);
  const seconds = Math.floor(totalSeconds - hours * 3600 - minutes * 60);
  const display =
    (hours > 0 || forceHours ? hours + ':' + pad(minutes) : minutes) +
    (includeSeconds ? ':' + pad(seconds) : '');

  if (includeUnits) {
    return display + (hours > 0 || forceHours ? ' hours' : ' minutes');
  }
  return display;
}
